export default "__VITE_ASSET__Dd6kxTEj__"